module.exports = __webpack_public_path__ + "img/TheRiseFramework.f0f2ac40.png";